import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

type Props = {
  hide: () => void;
  isShow: boolean;
};

export const NoSortingAssetsModal = ({
  hide,
  isShow,
}: Props): React.ReactElement => {
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-lg">
            分類方法・分類されない資産について
          </div>
          <div className="text-sm mb-2">
            <div className="mt-4  font-bold">・ご注意</div>
            <div>以下の資産は「その他」に分類されます。</div>
            <div>・マネーツリー連携しているすべての資産</div>
            <div>・現金、手入力資産</div>
            <div>・データ取得中の銘柄情報</div>
            <div>・一部のアクティブファンド等、分類ができない投資信託</div>

            <div className="mt-4  font-bold">
              ・保有資産のポートフォリオ分類の方法について
            </div>
            <div>
              ファンドがベンチマークや参考指標としているインデックスをもとに分類しアセットクラスへマッピングしています。
            </div>
            <div>
              分類が困難な投資信託、バランス型投資信託、コモデティティ関連に投資する投資信託、転換社債に投資する投資信託は「その他」として対象外とします。
            </div>
            <div>
              先進国・新興国株式（広域）、先進国・新興国債券（広域）については、分析上はそれぞれエクスポージャーの高い先進国株式、先進国債券に分類しています。
            </div>
          </div>
          <button
            className="mt-2 p-2 font-bold text-bluegray-500 justify-center w-full text-sm"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
